import React from 'react';
import styled from 'styled-components';

const promptTips = [
  {
    title: "Choose the Right Model & Approach",
    description: "Consider your goal: Do you need a quick answer, in-depth thinking, or comprehensive research? Different models excel at different tasks. Match the model to your specific needs."
  },
  {
    title: "Iterate Your Prompts",
    description: "Refine prompts collaboratively with the LLM itself. Ask it to help design better prompts for your specific needs, or gradually refine based on previous responses."
  },
  {
    title: "Specify Response Format",
    description: "Clearly state your desired output format: table, text, code, image, etc. Being explicit about structure saves time and ensures you get exactly what you need."
  },
  {
    title: "Manage Context Effectively",
    description: "LLMs have limited context windows. Keep conversations focused, remove irrelevant information, and place critical details at the beginning or end of your prompts."
  }
];

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
  margin: 2rem 0;
`;
const Card = styled.div`
  background: #f6f8fa;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.07);
  padding: 1.5rem 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: box-shadow 0.2s, transform 0.2s;
  &:hover {
    box-shadow: 0 6px 18px rgba(25, 118, 210, 0.13);
    transform: translateY(-2px) scale(1.02);
  }
`;
const Icon = styled.div`
  font-size: 1.7rem;
  margin-bottom: 0.5rem;
  color: #1976d2;
`;
const Title = styled.h4`
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
  color: #1976d2;
  font-weight: 600;
`;
const Desc = styled.p`
  margin: 0;
  color: #222;
  font-size: 1rem;
`;

const icons = ['🧠', '🔁', '📋', '📝'];

const CorePromptingTechniques = () => (
  <div>
    <h2 style={{ textAlign: 'center', color: 'var(--primary-color)', fontSize: '1.8rem', fontWeight: 700, marginBottom: '1.5rem' }}>Core Prompting Techniques</h2>
    <Grid>
      {promptTips.map((tip, i) => (
        <Card key={tip.title}>
          <Icon>{icons[i % icons.length]}</Icon>
          <Title>{tip.title}</Title>
          <Desc>{tip.description}</Desc>
        </Card>
      ))}
    </Grid>
  </div>
);

export default CorePromptingTechniques; 